import BaseApi from '../base/base'
import CourseTag from '../../models/course_tag'

export default class CourseTagApi extends BaseApi {
  constructor() {
    super()
    this.path = '/course_tags'
  }

  async index(params = {}) {
    this.path = '/course_tags'
    const response = await this.getRequest(params)
    return response.data.map((element) => new CourseTag(element))
  }

  async my(params = {}) {
    this.path = '/course_tags/my'
    const response = await this.getRequest(params)
    return response.data.map((element) => new CourseTag(element))
  }
}
